module.exports = __webpack_public_path__ + "img/distributorship.59d8c6f4.png";